export default "__VITE_ASSET__DGqNQNJs__"